const stadistics = {
  backbtn: "Go Back",
  pumpHousingC: "Pump Housing Temperature (°C)",
  pumpHousingF: "Pump Housing Temperature (°F)",
  mapCFSBar11: "API 11 In Board and Out Board Pressure (bar)",
  mapSHTc: "API 23 Stuffing Box Temperature (°F)",
  mapSHPbar: "API 23 Stuffing Box Pressure (bar)",
  mapFITc: "API 23 FI Temperature (°C)",
  mapCwTc: "API 23 Cooling Water Temperature In - Out(°C)",
  mapfCTc: "API 32 Out Board and In Board Temperature (°C)",
  mapfCbar: "API 32 Out Board and In Board Pressure (bar)",
  mapCwInOut52: "API 52 Cooling Water Temperature In and Out (°C)",
  mapOilInOut52: "API 52 Oil Temperature (°C) In and Out",
  mapShPbar52: "API 52 Stuffing Box Pressure (bar)",
  mapPBar52: "API 52 Pressure (bar)",
  mapTankLevel52: "API 52 Tank Level (mm)",
  mapIaPbar53b: "API 53b Instrument Air Pressure (bar)",
  mapSysPbar53b: "API 53b System Pressure (bar)",
  mapcBpiBpoTc53b: "API 53b In Board Bpi Bpo Temperature (°C)",
  mapfBpiBpoTc53b: "API 53b Out Board Bpi Bpo Temperature (°C)",
  mapcBpiBpoBar53b: "API 53b Out Board and In Board Bpo Pressure (Bar)",
  mapfBpiBpoBar53b: "API 53b Out Board Bpi Bpo Pressure (Bar)",
  mapcCwInOut53b: "API 53b In Board Cooling Water In Out Temperature (°C)",
  mapfCwInOut53b: "API 53b Out Board Cooling Water In Out Temperature (°C)",
  mapFCRs53b:
    " API 53b Refilling Systems In Board and Out Board - Pressure (bar)",
  mapBpiBpoTc54: "API 54 In Board BPI and BPO Temperature (°C)",
  mapBpiBpoPbar54: "API 54 In Board BPI - BPO Pressure (bar)",
  mapCwInOut54: "API 54 In Board Cooling Water Temperature In and Out (°C)",
  mapFlowL54: "API 54 In Board Flow (l/min)",
  mapMotorTc54: "API 54 In Board Motor Temperature (°C)",
  mapTankLevel54: "API 54 In Board Tank Level (mm)",
  mapfBpiBpoTc54: "API 54 Out Board BPI and BPO Temperature (°C)",
  mapfBpiBpoPbar54: "API 54 Out Board BPI - BPO Pressure (bar)",
  mapfCwInOut54: "API 54 Out Board Cooling Water Temperature In and Out (°C)",
  mapfFlowL54: "API 54 Out Board Flow (l/min)",
  mapfMotorTc54: "API 54 Out Board Motor Temperature (°C)",
  mapfTankLevel54: "API 54 Out Board Tank Level (mm)",
  imapPumpHousing: "Pump Housing Temperature (°F)",
  imapCFSpsi11: "API 11 In Board and Out Board Pressure (psi)",
  imapSHTc: "API 23 Stuffing Box Temperature (°F)",
  imapSHPbar: "API 23 Stuffing Box Pressure (psi)",
  imapFITc: "API 23 FI Temperature (°F)",
  imapCwTc: "API 23 Cooling Water Temperature In - Out (°F)",
  imapfCTf: "API 32 Out Board and In Board Temperature (°F)",
  mapfCpsi: "API 32 Out Board and In Board Pressure (psi)",
  imapCwInOut52: " API 52 Cooling Water Temperature In and Out (°F)",
  imapOilInOut52: "API 52 Oil Temperature (°F) In and Out",
  imapShPbar52: "API 52 Stuffing Box Pressure (psi)",
  imapPBar52: "API 52 Pressure (psi)",
  imapTankLevel52: "API 52 Tank Level (mm)",
  imapIaPbar53b: "API 53b Instrument Air Pressure (psi)",
  imapSysPbar53b: "API 53b System Pressure (psi)",
  imapcBpiBpoTc53b: "API 53b In Board Bpi Bpo Temperature (°F)",
  imapfBpiBpoTc53b: "API 53b Out Board Bpi Bpo Temperature (°F)",
  imapcBpiBpoBar53b: "API 53b Out Board and In Board Bpo Pressure (psi)",
  imapfBpiBpoBar53b: "API 53b Out Board Bpo Pressure (psi)",
  imapcCwInOut53b: "API 53b In Board Cooling Water In Out Temperature (°F)",
  imapfCwInOut53b: "API 53b Out Board Cooling Water In Out Temperature (°F)",
  imapFCRs53b:
    " API 53b Refilling Systems In Board and Out Board - Pressure (psi)",
  imapBpiBpoTc54: "  API 54 In Board BPI and BPO Temperature (°F)",
  imapBpiBpoPbar54: "API 54 In Board BPI - BPO Pressure (psi)",
  imapCwInOut54: " API 54 In Board Cooling Water Temperature In and Out (°F)",
  imapFlowL54: "API 54 In Board Flow (gal/min)",
  imapMotorTc54: "API 54 In Board Motor Temperature (°F)",
  imapTankLevel54: "API 54 In Board Tank Level (l)",
  imapfBpiBpoTc54: "API 54 Out Board BPI and BPO Temperature (°F)",
  imapfBpiBpoPbar54: "API 54 Out Board BPI - BPO Pressure(psi)",
  imapfCwInOut54: " API 54 Out Board Cooling Water Temperature In and Out (°F)",
  imapfFlowL54: "API 54 Out Board Flow (gal/min)",
  imapfMotorTc54: "API 54 Out Board Motor Temperature (°F)",
  imapfTankLevel54: "API 54 Out Board Tank Level (l)",
  commentList: "Comment List",
  inspectionDate: "Inspection Date",
  comment: "Comment"
};
export default stadistics;
